import { app } from '../../bootstrap/core';
import {
  AdminService,
  CreditorsService,
  LoginService,
  PADContactService,
  ReportService,
  SepaCountries,
  TicketsProvider,
  TicketsService,
} from './dataSource';

app.service('loginService', LoginService);
app.service('adminService', AdminService);
app.service('creditorsService', CreditorsService);
app.service('ticketsDataService', TicketsService);
app.provider('Tickets', TicketsProvider);
app.factory('SepaCountries', SepaCountries);
app.service('reportService', ReportService);
app.service('padContactService', PADContactService);
